import { useContext } from 'react'
import { ConfigContext } from '@/context/Config/ConfigContext'

/**
 * Hook para acceder a la configuración segura
 * @returns Contexto de configuración segura
 */
export const useSecureConfig = () => {
  const context = useContext(ConfigContext)

  if (!context) {
    throw new Error('useSecureConfig debe ser usado dentro de ConfigProvider')
  }

  return context
}

/**
 * Hook para obtener las URLs de API desde la configuración segura
 * @returns URLs de API o undefined si no están cargadas
 */
export const useApiUrls = () => {
  const { secureConfig } = useSecureConfig()
  return secureConfig?.apiUrls
}

/**
 * Hook para obtener la configuración de Azure desde la configuración segura
 * @returns Configuración de Azure o undefined si no está cargada
 */
export const useAzureConfig = () => {
  const { secureConfig } = useSecureConfig()
  return secureConfig?.azure
}
